import { render } from "./PatientSearch.vue?vue&type=template&id=06ed8e2a&scoped=true&ts=true"
import script from "./PatientSearch.vue?vue&type=script&lang=ts"
export * from "./PatientSearch.vue?vue&type=script&lang=ts"

import "./PatientSearch.vue?vue&type=style&index=0&id=06ed8e2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ed8e2a"]])

export default __exports__